module.exports = __webpack_public_path__ + "img/cash.793fde2a.svg";